import React from 'react';

import classNames from 'classnames';

import { SuccessCheckIcon } from 'features/order-tracker/shared-components/svg';

import styles from './styles.module.scss';

export const DeliveryTrackingMilestone: React.FC<components.DeliveryTrackingMilestone> = ({
  title,
  isCompleted,
  children,
  className,
}) => (
  <div className={classNames(styles.trackingMilestone, className)}>
    <div
      className={classNames(styles.trackingIcon, { [styles.complete]: isCompleted, [styles.incomplete]: !isCompleted })}
    >
      <SuccessCheckIcon />
    </div>
    <p>{title}</p>
    {children}
  </div>
);
